import styled from "styled-components"

import { Bounds } from "../grid"
import { BaseContainer } from "../container"
import { H4 } from "../typography"
import { devices } from "../../utils/styleVariables"
import bgUrl from "../../images/testimonial-bg.svg"

const TestimonialContainer = styled(BaseContainer)`
  & .slick-list {
    width: 100%;
  }

  @media ${devices.tablet} {
    background: url(${bgUrl}) center / contain no-repeat;
  }
`

const CardContainer = styled(Bounds)`
  background-color: #fff;
  max-width: 1096px;
  width: 80%;
  border-radius: 10px;
  padding: 24px;
  margin: 90px 0;
  box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 16%);
`

const CardTextContainer = styled(Bounds)`
  margin-bottom: 8px;
  & .title {
    margin-right: 16px;
  }
  & ${H4} {
    margin-bottom: 8px;
  }
  @media ${devices.tablet} {
    margin-bottom: 40px;
  }
`

export { TestimonialContainer, CardContainer, CardTextContainer }
